// Get List of All RMA Products
window._rma = window._rma || {};
_rma.rmaFormContainer = document.getElementById('rma-form-container');

if (null !== document.getElementById(`rma-product-list-json`)) {
    _rma.productList = JSON.parse(
        document.getElementById(`rma-product-list-json`).innerHTML);
}

if (null !== document.querySelectorAll('.product-selection select')) {
    _rma.productSelects = document.querySelectorAll('.product-selection select');
}

// Trigger Add to Cart on the Collection Page
let outletAddToCart = document.querySelectorAll('.outlet__addToCart');
if (outletAddToCart.length > 0) {
    outletAddToCart.forEach(function (button) {
        let variantRow = button.parentNode.parentNode;
        let addVariantToCartButton = variantRow.querySelector('[data-add-to-cart]');

        button.addEventListener('click', function (e) {
            e.preventDefault();
            addVariantToCartButton.click();
        });
    });
}

let saleAddToCart = document.querySelectorAll('.sale__addToCart');
if (saleAddToCart.length > 0) {
    saleAddToCart.forEach(function (button) {
        let variantRow = button.parentNode.parentNode;
        let addVariantToCartButton = variantRow.querySelector('[data-add-to-cart]');

        button.addEventListener('click', function (e) {
            e.preventDefault();
            addVariantToCartButton.click();
        });
    });
}

if (null !== document.querySelector('body.template-product')) {
    let withAccordion = document.querySelector('.with-accordion');
    if (null !== withAccordion) {
        let accordionLabels = withAccordion.querySelectorAll('.faq__accordion-label');
        accordionLabels.forEach(function (accordionLabel) {
            accordionLabel.addEventListener('click', function() {
                let labelParent = accordionLabel.parentNode;
                let faqAnswer = labelParent.querySelector('.faq__accordion-answer');

                if (labelParent.dataset.open === 'true') {
                    labelParent.setAttribute('data-open', 'false');
                    slideUpPure(faqAnswer, 750);
                } else {
                    labelParent.setAttribute('data-open', 'true');
                    slideDownPure(faqAnswer, 750);
                }
            });
        });
    }

    setTimeout(function () {
        // Select the first option in each variant category
        let firstProductImageThumbnail = document.querySelector('.product-thumbnails .product-thumbnails__item .product-thumbnails__item-link');
        if (null !== firstProductImageThumbnail) {
            //firstProductImageThumbnail.click();
        }

        let firstProductChip = document.querySelector('.product__color-chips .product__chip');
        if (null !== firstProductChip) {
            //firstProductChip.click();
        }

        let firstProductColorSwatch = document.querySelector('.product__color-swatches .product__color-swatch');
        if (null !== firstProductColorSwatch) {
            //firstProductColorSwatch.click();
        }

        let dataAltLogic = document.querySelector('[data-alt-logic]');

        if (dataAltLogic) {
            let optionSizeSelect = document.querySelector('[name="options[Size]"]');
            let optionStyleSelect = document.querySelector('[name="options[Style]"]');
            let optionColorSelect = document.querySelector('[name="options[Color]"]');
            let optionArgs = {}

            if (null !== optionSizeSelect) {
                optionArgs["currentSelect"] = optionSizeSelect;
                optionArgs["colorOptionPosition"] = getColorOptionPosition();

                optionSizeSelect.addEventListener('change', function () {
                    hideNonExistentVariants(optionSizeSelect, optionArgs);
                });

                hideNonExistentVariants(optionSizeSelect, optionArgs);
            }

            if (null !== optionStyleSelect) {
                optionStyleSelect.addEventListener('change', function () {
                    hideNonExistentVariants(optionStyleSelect, optionArgs);
                });

                hideNonExistentVariants(optionStyleSelect, 'Style', getColorOptionPosition());
            }
        } else {
            let option1Select = document.getElementById('Option1');
            let option2Select = document.getElementById('Option2');

            if (null !== option1Select) {
                option1Select.addEventListener('change', function () {
                    hideNonExistentVariants(option1Select, option1Select.getAttribute('name'), getColorOptionPosition());
                });
                hideNonExistentVariants(option1Select, option1Select.getAttribute('name'), getColorOptionPosition());
            }

            if (null !== option2Select) {
                option2Select.addEventListener('change', function () {
                    hideNonExistentVariants(option2Select, option2Select.getAttribute('name'), getColorOptionPosition());
                });
                hideNonExistentVariants(option2Select, option2Select.getAttribute('name'), getColorOptionPosition());
            }
        }

    }, 500);

    let productReview = document.querySelector('.stamped-product-reviews-badge');
    const config = { attributes: true, childList: true, subtree: true };

    function updateProductColor (variant) {
        let productColors = document.querySelectorAll('.product_color')
        if (productColors.length === 0) return;

        if (variant) {
            productColors.forEach(productColor => {
                const index = productColor.dataset.optionIndex;
                if (index && variant[index]) {
                    productColor.innerHTML = variant[index]
                }
            });
        } else {
            let selectedSwatch = document.querySelector('.product__color-swatch.selected, .product__chip.selected')
            if (selectedSwatch) {
                const label = selectedSwatch.dataset.label || selectedSwatch.dataset.button || selectedSwatch.innerText.trim();
                productColors.forEach(productColor => {
                    productColor.innerHTML = label;
                });
            }
        }
    }

    document.addEventListener('product:variant-change', function (evt) {
        const variant = evt.detail.variant;
        updateProductColor(variant);

        if (variant && variant.featured_media) {
            updateImageSlider(document.querySelector('.product'), variant.featured_media.id);
        }

        [100, 300, 600, 1000].forEach(delay => {
            setTimeout(function() {
                updateProductColor(variant);
            }, delay);
        });
    });

    document.addEventListener('change', function (evt) {
        if (evt.target.closest('.product__form, .product-form, [data-product-form]')) {
            setTimeout(function() {
                updateProductColor();
            }, 200);
        }
    });
}

if (null !== _rma.rmaFormContainer && null !== _rma.productList) {
    $(function () {
        initRMA();

        function initRMA() {
            // Generate Province dropdown
            new window.Shopify.CountryProvinceSelector('AddressCountry',
                'AddressProvince', {
                    hideElement: 'province__field',
                });

            // Init Datepicker
            $('#datepicker').datepicker({
                inline: true,
                onSelect: function () {
                    var dateObject = $(this).datepicker('getDate');
                    let hiddenDate = document.getElementById('date-of-original-purchase');
                    // Set Purchase Date in form
                    hiddenDate.value = dateObject;
                    // console.log(dateObject);
                },
            });

            _rma.productSelects.forEach(function (singleSelect) {
                singleSelect.addEventListener('change', function (e) {
                    getProductInfo(singleSelect);
                });
            });

            let dataForHiddenTextarea = document.querySelectorAll('.for-hidden-textarea');
            dataForHiddenTextarea.forEach(function (item) {
                item.addEventListener('change', function (e) {
                    updateHiddenTextarea(e.target, dataForHiddenTextarea);
                })
            })
        }
    });
}

$(function () {
    let bodyElement = document.body;
    if (bodyElement.classList.contains('template-product')) {
        let initialWindowWidth = $(window).width();
        let productMediaContainer = document.querySelector('.product__media');
        let args = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            prevArrow: '<div class="arrow arrow-left"><i class="fa-solid fa-chevron-left"></i></div>',
            nextArrow: '<div class="arrow arrow-right"><i class="fa-solid fa-chevron-right"></i></div>'
        }

        window.productMedia = $(productMediaContainer);

        function handleSlick() {
            let windowWidth = $(window).width();
            $('.product__media').each(function() {
                let $media = $(this);
                if (windowWidth <= 960 && !$media.hasClass('slick-initialized')) {
                    if ($media.data('flickity')) {
                        $media.flickity('destroy');
                    }
                    $media.children().removeClass('hidden');
                    $media.slick(args);
                } else if (windowWidth >= 961 && $media.hasClass('slick-initialized')) {
                    let currentSlide = $media.slick('slickCurrentSlide');
                    $media.slick('unslick');
                    $media.children().each(function (index) {
                        if (index !== currentSlide) {
                            $(this).addClass('hidden');
                        }
                    });
                }
            });
        }

        $(window).resize(handleSlick);
        handleSlick();

        // Thumbnail click handler for mobile slider
        $(document).on('click', '[data-product-thumbnail]', function() {
            let mediaId = $(this).data('thumbnail-id');
            let productContainer = $(this).closest('.product')[0];
            updateImageSlider(productContainer, mediaId);
        });
    }
});

waitForElementToDisplay('.stamped-rewards-spendings', updateRewardsPage, 1000, 9000);

// Functions
function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
    var startTimeInMs = Date.now();
    (function loopSearch() {
        if (document.querySelector(selector) != null) {
            callback();
            return;
        }
        else {
            setTimeout(function () {
                if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
                    return;
                loopSearch();
            }, checkFrequencyInMs);
        }
    })();
}

function updateImageSlider(productContainer, mediaID) {
    if (!productContainer || !mediaID) {return false}

    let $productMedia = $(productContainer).find('.product__media');
    if ($productMedia.length === 0) return false;

    if ($productMedia.hasClass('slick-initialized')) {
        let associatedSlide = productContainer.querySelector(`.product__media-item:not(.slick-cloned)[data-media-item-id="${mediaID}"]`)
        if (associatedSlide) {
            let index = $(associatedSlide).data('slick-index');
            $productMedia.slick('slickGoTo', index);
        }
    } else {
        $productMedia.find('.product__media-item').addClass('hidden');
        $productMedia.find(`.product__media-item[data-media-item-id="${mediaID}"]`).removeClass('hidden');

        $(productContainer).find('[data-product-thumbnail]').removeClass('active');
        $(productContainer).find(`[data-product-thumbnail][data-thumbnail-id="${mediaID}"]`).addClass('active');
    }
}

function updateRewardsPage() {
    let redeemNowBannerButton = document.querySelector('[data-widget-type="rewards-summary"] .stamped-rewards-widget-btn-redeem');
    if (redeemNowBannerButton) {
        redeemNowBannerButton.setAttribute('href', '#shopify-block-08f841c4-0fe8-4ebc-847b-5a4d57b5f175')
        redeemNowBannerButton.setAttribute('onclick', '')
    }

    let stampedRewardButtons = document.querySelectorAll('.stamped-rewards-widget-button');
    if (stampedRewardButtons.length > 0) {
        stampedRewardButtons.forEach((stampedRewardButton) => {
            if (stampedRewardButton.innerHTML === 'Login' || stampedRewardButton.innerHTML === 'login') {
                stampedRewardButton.innerHTML = 'Log In';
            } else if (stampedRewardButton.innerHTML === 'Signup' || stampedRewardButton.innerHTML === 'signup') {
                stampedRewardButton.innerHTML = 'Sign Up';
            }
        });
    }

    let spendingContainer = document.querySelector('.stamped-rewards-widget-campaigns-spendings');
    if (spendingContainer) {
        let inners = spendingContainer.querySelectorAll('.stamped-rewards-widget-item-inner');
        if (inners.length > 0) {
            inners.forEach((inner) => {
                let buttons = document.createElement('div');
                let signup = inner.querySelector('[data-type="signup"]');
                let login = inner.querySelector('[data-type="login"]');
                let view = inner.querySelector('[data-type="view"]');
                buttons.classList.add('buttons');
                buttons.append(signup);
                buttons.append(login);
                buttons.append(view);
                inner.append(buttons);
            });
        }
    }

    let referralContainer = document.querySelector('[data-widget-type="rewards-referral"]');
    let referralForm = document.querySelector('.stamped-rewards-page-campaigns-refer');
    if (referralContainer) {
        let newContainer = document.createElement('div');
        newContainer.classList.add('inner-container');
        newContainer.innerHTML = `<div class="row">
          <div class="column image-column"></div>
          <div class="column referral-column"></div>
        </div>`;

        if (referralForm) {
            let referralColumn = newContainer.querySelector('.referral-column');
            referralColumn.append(referralForm);

            let imageColumn = newContainer.querySelector('.image-column');
            let referralImage = document.querySelector('.referral-image');
            imageColumn.append(referralImage);
            referralImage.style.display = 'block';
        }

        referralContainer.append(newContainer);
        referralContainer.style.display = 'block';
    }

    let rewardsEarningsContainer = document.querySelector('[data-widget-type="rewards-earnings-v2"] .stamped-rewards-widget-campaigns-earnings');
    if (rewardsEarningsContainer) {
        let tempElement = document.createElement('div');
        tempElement.classList.add('notice');
        tempElement.innerHTML = "**Limited to 5 product reviews per account";

        rewardsEarningsContainer.append(tempElement);
    }
}

function updateHiddenTextarea(formInput, forTextArea) {
    let id = formInput.getAttribute('id');
    let noNewLineIDBank = ['city', 'AddressProvince', 'AddressCountry'];
    let newText = '';
    let location = '';

    forTextArea.forEach(function (item) {
        if (id !== 'address-2' && item.value !== '') {
            if (noNewLineIDBank.includes(item.getAttribute('id'))) {
                newText += item.value + ', ';
            } else {
                newText += item.value + '&#13;&#10;';
            }
        } else {
            if (item.value !== '') {
                newText += item.value + '&#13;&#10;';
            }
        }
    });

    document.getElementById('combined-information').innerHTML = newText;
    document.getElementById('combined-information').value = newText;
    console.log(newText);
}

function hideNonExistentVariants(currentSelect, currentOptionType, colorOptionPosition) {
    let dataAltLogic = document.querySelector('[data-alt-logic]');

    console.log(getColorOptionPosition());
    console.log('currentSelect:', currentSelect);
    console.log('currentOptionType:', currentOptionType);

    if (!dataAltLogic) {
        let mainOptionSelect = document.getElementById('variant-selector');
        let allVariantOptions = mainOptionSelect.querySelectorAll('option');
        let allColorButtons = document.querySelectorAll('.product__color-swatch');
        let noColorSwatchesAvailable = document.getElementById(
            'no-available-swatches');
        let option1Select = document.getElementById('Option1');
        let option2Select = document.getElementById('Option2');
        let option3Select = document.getElementById('Option3');
        let allVariantsArray = [];

        allVariantOptions.forEach(function (option) {
            option.innerText = option.innerText.replace(/ {1,}/g, ' ');
            option.innerText = option.innerText.trim();
            allVariantsArray.push(option.innerText);
        });

        let filteredVariantsArray;
        if (option2Select) {
            filteredVariantsArray = allVariantsArray.filter(option => {
                return option.includes(option1Select.value);
            });
        } else {
            filteredVariantsArray = allVariantsArray;
        }

        allColorButtons.forEach(function (button) {
            let color = button.dataset.label;
            button.classList.remove('unavailable');

            if (!filteredVariantsArray.some(v => v.includes(color))) {
                button.classList.add('unavailable');
                //console.log('No match using \'' + color + '\'');
            } else {
                //console.log('Match using \'' + color + '\'');
            }
        });

        if (allColorButtons.length >= filteredVariantsArray.length &&
            filteredVariantsArray.length !== 0) {
            //noColorSwatchesAvailable.style.display = 'none';
        } else {
            //noColorSwatchesAvailable.style.display = 'flex';
        }
    }
}

function getColorOptionPosition() {
    let colorOptionSelect = document.querySelector('[name="options[Color]"]');

    if (colorOptionSelect) {
        return parseInt(colorOptionSelect.getAttribute('id').replace('Option', ''));
    } else {
        return false;
    }
}

function getProductInfo(productSelect) {
    // Let's make sure we don't execute anything if there's no value in the select
    if ('' === productSelect.value || null === productSelect.value) return;

    let defectiveProductContainer = productSelect.parentNode.parentNode.parentNode;
    let newIndex = defectiveProductContainer.dataset.defectiveIndex;
    let productSelectContainer = productSelect.parentNode;
    let currentOptions = productSelect.querySelector(`option[value="${productSelect.value}"]`).dataset.optionsWithValues;
    let parsedOptions = JSON.parse(currentOptions);
    let existingOptions = defectiveProductContainer.querySelectorAll('.product__options');
    let optionRowContainer = defectiveProductContainer.querySelector('.optionRowContainer');
    let quantityInput = defectiveProductContainer.querySelector(`#product-${newIndex}-quantity`);

    var result = _rma.productList.filter(obj => {
        return obj.title === productSelect.value;
    });

    if (null !== existingOptions) {
        existingOptions.forEach(function (existingOption, index) {
            existingOption.parentNode.removeChild(existingOption);
        });
    }

    if (null === parsedOptions) return;
    parsedOptions.filter(parsedOption => parsedOption.name !== 'Color').forEach(function (parsedOption, index) {
        if (index === 0) {
            productSelectContainer.parentNode.insertBefore(buildOptionSelector(productSelect, parsedOption, newIndex),
                productSelectContainer.nextSibling);
        } else {
            let existingOptions = defectiveProductContainer.querySelectorAll('.product__options');
            existingOptions[(index - 1)].parentNode.insertBefore(buildOptionSelector(productSelect, parsedOption, newIndex),
                existingOptions[(index - 1)].nextSibling);
        }
    });

    quantityInput.value = 0;
    getFinalOptionsBasedOnQuantity(quantityInput, newIndex);
    document.querySelector('.add-defective-product').style.display = 'block';
}

function buildOptionSelector(productSelect, parsedOption, newIndex) {
    // console.log(parsedOptions);
    let optionContainer = document.createElement('div');
    optionContainer.classList.add(`${parsedOption.name.toLowerCase()}`);
    optionContainer.classList.add('contact__field');
    optionContainer.classList.add('product__options');

    let label = document.createElement('label');
    label.setAttribute('for', `product-${newIndex}-${parsedOption.name.toLowerCase()}`);
    label.innerText = `${parsedOption.name}:*`;

    let select = document.createElement('select');
    select.setAttribute('id', `product-${newIndex}-${parsedOption.name.toLowerCase()}`);
    select.setAttribute('name', `contact[Product ${newIndex} ${parsedOption.name}]`);

    let firstOption = document.createElement('option');
    firstOption.innerText = `Select Your ${parsedOption.name}`;
    firstOption.setAttribute('value', '');
    select.appendChild(firstOption);

    parsedOption['values'].forEach(function (item, index) {
        let option = document.createElement('option');
        option.innerText = item;
        option.value = item;
        select.appendChild(option);
    });

    optionContainer.appendChild(label);
    optionContainer.appendChild(select);
    return optionContainer;
}

function getFinalOptionsBasedOnQuantity(quantityInput, newIndex) {
    let productContainer = document.querySelector(`[data-defective-index="${newIndex}"]`);
    let productSelect = productContainer.querySelector(`#product-${newIndex}-select`);
    let quantityContainer = productContainer.querySelector('.quantity');
    let oldColor = document.querySelector(`[data-defective-index="${newIndex}"] .optionRowContainer.contact__field`);
    let optionRowContainer = document.querySelector(`[data-defective-index="${newIndex}"] .optionRowContainer`);
    let optionRowArgs = {};

    console.log(typeof parseInt(quantityInput.value));
    console.log(parseInt(quantityInput.value) <= 0);
    console.log(parseInt(quantityInput.value) <= 0 && null !== optionRowContainer);

    if ((parseInt(quantityInput.value) <= 0)) {
        if (null !== optionRowContainer) {
            optionRowContainer.parentNode.removeChild(optionRowContainer);
        }
    } else {
        // Do nothing when the Quantity is lower than 1
        if ('' === productSelect.value || null === productSelect.value) return;
        // Remove Old Color Rows
        if (null !== oldColor) {
            oldColor.parentNode.removeChild(oldColor);
        }

        // Build Color Inputs with Lot Numbers
        let currentOptions = productSelect.querySelector(`option[value="${productSelect.value}"]`).dataset.optionsWithValues;
        let parsedOptions = JSON.parse(currentOptions);
        let colorOptions = parsedOptions.filter(obj => {
            return obj.name === 'Color';
        })[0];

        if (null === colorOptions) {
            optionRowArgs = {
                productSelect: productSelect,
                colorOptions: colorOptions,
                newIndex: parseInt(newIndex),
                variantCount: parseInt(quantityInput.value),
                hasColors: false
            };
            optionRowContainer = buildOptionRows(optionRowArgs);
        } else {
            optionRowArgs = {
                productSelect: productSelect,
                colorOptions: colorOptions,
                newIndex: parseInt(newIndex),
                variantCount: parseInt(quantityInput.value),
                hasColors: true
            };
            optionRowContainer = buildOptionRows(optionRowArgs);
        }

        quantityContainer.parentNode.insertBefore(optionRowContainer,
            quantityContainer.nextSibling);
    }
}

function buildOptionRows(optionRowArgs) {
    console.log(optionRowArgs);

    let optionRowContainer = document.createElement('div'), i = 1;
    optionRowContainer.classList.add('optionRowContainer');
    optionRowContainer.classList.add('contact__field');
    optionRowContainer.classList.add('without-color-select');

    while (i <= optionRowArgs.variantCount) {
        let optionRow = document.createElement('div');
        optionRow.classList.add('optionRow', 'grid');
        let lotColumn = document.createElement('div');

        if (typeof optionRowArgs.colorOptions !== 'undefined') {
            let colorColumn = document.createElement('div');
            colorColumn.classList.add('grid__item--one-half');
            lotColumn.classList.add('grid__item--one-half');

            let colorLabel = document.createElement('label');
            colorLabel.setAttribute('for', `product-${optionRowArgs.newIndex}-variant-${i}-color`);
            colorLabel.innerText = 'Color:*';

            let select = document.createElement('select');
            select.setAttribute('id', `product-${optionRowArgs.newIndex}-variant-${i}-color`);
            select.setAttribute('class', `product-${optionRowArgs.newIndex}-color`);
            select.setAttribute('name',
                `contact[Product ${optionRowArgs.newIndex} Variant ${i} Color]`);

            let firstOption = document.createElement('option');
            firstOption.innerText = 'Select';
            firstOption.setAttribute('value', '');
            select.appendChild(firstOption);

            optionRowArgs.colorOptions['values'].forEach(function (colorOption) {
                let option = document.createElement('option');
                option.innerText = colorOption;
                option.value = colorOption;
                select.appendChild(option);
            });

            optionRowContainer.classList.remove('without-color-select');
            colorColumn.appendChild(colorLabel);
            colorColumn.appendChild(select);
            optionRow.appendChild(colorColumn);
            console.log(optionRow);
            console.log(colorColumn);
        }

        if (!lotColumn.classList.contains('grid__item--one-half')) {lotColumn.classList.add('grid__item');}

        let lotLabel = document.createElement('label');
        lotLabel.setAttribute('for', `product-${optionRowArgs.newIndex}-variant-${i}-lot-number`);
        lotLabel.innerText = 'Lot #:*';

        let lotInput = document.createElement('input');
        lotInput.setAttribute('type', `text`);
        lotInput.setAttribute('id', `product-${optionRowArgs.newIndex}-variant-${i}-lot-number`);
        lotInput.setAttribute('name',
            `contact[Product ${optionRowArgs.newIndex} Variant ${i} Lot Number]`);
        lotInput.setAttribute('required', '');

        let tooltip = document.createElement('i');
        tooltip.classList.add('fas', 'fa-question-circle');
        tooltip.setAttribute('title',
            'The LOT # can be found behind the cloth label on the diapering product.');

        lotColumn.appendChild(lotLabel);
        lotColumn.appendChild(lotInput);
        lotColumn.appendChild(tooltip);
        optionRow.appendChild(lotColumn);
        optionRowContainer.appendChild(optionRow);
        i++;
    }

    return optionRowContainer;
}

function addDefectiveProduct(addButton) {
    //const firstDefectiveProduct = document.querySelector('.first-product');
    let defectiveProductCount = document.querySelectorAll(
        '.defective-product').length;
    let lastDefectiveProduct = document.querySelectorAll(
        '.defective-product')[defectiveProductCount - 1];

    let newDefectiveProduct = buildDefectiveProduct(defectiveProductCount);
    lastDefectiveProduct.parentNode.insertBefore(newDefectiveProduct,
        lastDefectiveProduct.nextSibling);
    _rma.productSelects = document.querySelectorAll('.product-selection select');
    _rma.productSelects.forEach(function (singleSelect) {
        singleSelect.addEventListener('change', function (e) {
            getProductInfo(singleSelect);
        });
    });
}

function updateDefectiveIndexes(defectiveProducts) {
    defectiveProducts.forEach(function (item, index) {
        item.setAttribute('data-defective-index', parseInt(index) + 1);
    });
}

function buildProductSelect(copiedDropdown, newIndex) {
    // Update attributes for the next product Section
    let newDropdown = copiedDropdown.cloneNode(true);
    let label = newDropdown.querySelector('label');
    let select = newDropdown.querySelector('select');
    label.setAttribute('for', `product-${newIndex}-select`);
    select.setAttribute('id', `product-${newIndex}-select`);
    select.setAttribute('name', `contact[Product ${newIndex} Select]`);

    return newDropdown;
}

function buildDefectiveProduct(oldCount) {
    const newIndex = oldCount + 1;

    // Product Select
    let originalDropdown = document.querySelector(
        '[data-defective-index="1"] .inner-product .product-selection');
    let copiedDropdown = originalDropdown.cloneNode(true);
    let updatedDropdown = buildProductSelect(copiedDropdown, newIndex);

    // Quantity
    let quantityInputContainer = document.createElement('div');
    quantityInputContainer.classList.add('quantity');
    quantityInputContainer.classList.add('contact__field');

    let quantityInputLabel = document.createElement('label');
    quantityInputLabel.setAttribute('for', `product-${newIndex}-quantity`);
    quantityInputLabel.innerText = 'Quantity:*';

    let quantityInput = document.createElement('input');
    quantityInput.setAttribute('onblur', `getFinalOptionsBasedOnQuantity(this, ${newIndex});`);
    quantityInput.setAttribute('type', 'number');
    quantityInput.setAttribute('id', `product-${newIndex}-quantity`);
    quantityInput.setAttribute('name', `contact[Product ${newIndex} Quantity]`);
    quantityInput.setAttribute('required', 'required');
    // Append quantity child elements
    quantityInputContainer.appendChild(quantityInputLabel);
    quantityInputContainer.appendChild(quantityInput);

    // Remove Button
    let removeButton = document.createElement('button');
    removeButton.classList.add('remove-defective-product', 'btn', 'btn--primary', 'btn--form');
    removeButton.innerText = 'Remove';
    removeButton.setAttribute('onclick', 'removeDefectiveProduct(this);');

    // Create the container
    let newProduct = document.createElement('div');
    let newProductInner = document.createElement('div');
    newProduct.classList.add('form-group');
    newProduct.classList.add('defective-product');
    newProductInner.classList.add('inner-product');
    newProduct.setAttribute('data-defective-index', newIndex);

    // Add all elements to the Product Container
    newProductInner.appendChild(updatedDropdown);
    newProductInner.appendChild(quantityInputContainer);
    newProductInner.appendChild(removeButton);
    newProduct.appendChild(newProductInner);
    return newProduct;
}

function removeDefectiveProduct(removeButton) {
    let productContainer = removeButton.parentNode.parentNode;
    productContainer.parentNode.removeChild(productContainer);
    updateDefectiveIndexes(document.querySelectorAll('.defective-product'));
}

// Pure Javascript Slide Toggling
let slideUpPure = (target, duration= 1000) => {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';

    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;

    window.setTimeout( () => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        //alert("!");
    }, duration);
}

let slideDownPure = (target, duration= 1000) => {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;

    if (display === 'none') {
        display = 'block';
    }

    target.style.display = display;

    let height = target.offsetHeight;

    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;

    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';

    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');

    window.setTimeout( () => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
}

let slideTogglePure = (target, duration = 1000) => {
    if (window.getComputedStyle(target).display === 'none') {
        return slideDownPure(target, duration);
    } else {
        return slideUpPure(target, duration);
    }
}

